class EmployeeSummaryController {
    shift: any;
    private employeeSummary: any;
    constructor() {
        'ngInject';
    }

    public $onInit = () => {
        //this.employeeSummary.conflictingShift

        // {"employee":{"id":"baeaf909-4693-e711-80c2-0003ff4b7b6b","name":"Ebrina Kok","function":"Student VIG","functionId":"98e2e502-4693-e711-80c2-0003ff4b7b6b","addressId":null,"street":null,"number":null,"city":null},"conflictingShift":{"employeeId":"baeaf909-4693-e711-80c2-0003ff4b7b6b","name":null,"start":"2017-12-12T11:00:00","end":"2017-12-13T12:00:00","statusId":6,"shiftId":"827f9853-8cde-e711-80c3-0003ff433d90"},"availability":{"EmployeeId":"baeaf909-4693-e711-80c2-0003ff4b7b6b","name":"Ziek","value":null,"comment":null,"from":"2017-12-11T13:45:00","till":"2017-12-31T21:45:00"},"isAvailable":false,"subscription":{"employeeId":"baeaf909-4693-e711-80c2-0003ff4b7b6b","comment":"TEST TEST"},"history":{"count":10,"dates":["2017-12-12T11:00:00","2017-12-11T13:15:00","2017-12-09T11:45:00"]}}
    }

    public $onChanges = (change) => {
        if(this.employeeSummary && this.employeeSummary.conflictingShift && this.shift) {
            if(this.employeeSummary.conflictingShift.shiftId == this.shift.id) {
                this.employeeSummary.conflictingShift = null;
            }
        }
    }
}

export const employeeSummaryComponent = {
    bindings: {
        employeeSummary: '<',
        shift: '<',
        isEmbedded: '<'
    },
    controller: EmployeeSummaryController,
    template: require('./employeeSummary.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/shifts/employeeSummary.component.ts